import { EditPersonsGroup } from 'features/persons-group/edit';

export function EditPersonsGroupPage() {
  return <EditPersonsGroup />;
}
